import api from './api';

const API_BASE = '/api/external-bidding';

/**
 * Request OTP for employee authentication
 */
export const requestOtp = async (employeeCode) => {
  const response = await api.post(`${API_BASE}/request-otp`, { employee_code: employeeCode });
  return response.data;
};

/**
 * Verify OTP and get session token
 */
export const verifyOtp = async (employeeId, otp) => {
  const response = await api.post(`${API_BASE}/verify-otp`, { employee_id: employeeId, otp });
  return response.data;
};

/**
 * Get active bidding items (requires session)
 */
export const getItems = async (sessionToken) => {
  const response = await api.get(`${API_BASE}/items`, {
    headers: { 'X-Bid-Session': sessionToken }
  });
  return response.data;
};

/**
 * Place a bid (requires session)
 */
export const placeBid = async (sessionToken, itemId, amount, notifyOutbid = true, disclaimerAccepted = false) => {
  const response = await api.post(`${API_BASE}/place-bid`, 
    { item_id: itemId, amount, notify_outbid: notifyOutbid ? 1 : 0, disclaimer_accepted: disclaimerAccepted ? 1 : 0 },
    { headers: { 'X-Bid-Session': sessionToken } }
  );
  return response.data;
};

/**
 * Get employee's bids (requires session)
 */
export const getMyBids = async (sessionToken) => {
  const response = await api.get(`${API_BASE}/my-bids`, {
    headers: { 'X-Bid-Session': sessionToken }
  });
  return response.data;
};

/**
 * Check if session is valid
 */
export const checkSession = async (sessionToken) => {
  const response = await api.get(`${API_BASE}/check-session`, {
    headers: { 'X-Bid-Session': sessionToken }
  });
  return response.data;
};

/**
 * Logout
 */
export const logout = async (sessionToken) => {
  const response = await api.post(`${API_BASE}/logout`, {}, {
    headers: { 'X-Bid-Session': sessionToken }
  });
  return response.data;
};
